module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/babel-runtime/regenerator/index.js
// module id = 270
// module chunks = 0